import { UseMutationOptions, DefaultOptions, QueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import notify from '@/utils/shared/notify';

export type ApiFnReturnType<FnType extends (...args: any) => Promise<any>> = Awaited<ReturnType<FnType>>;

export type QueryConfig<T extends (...args: any[]) => any> = Omit<ReturnType<T>, 'queryKey' | 'queryFn'>;

export type MutationConfig<MutationFnType extends (...args: any) => Promise<any>> = UseMutationOptions<
  ApiFnReturnType<MutationFnType>,
  Error,
  Parameters<MutationFnType>[0]
>;

export const queryConfig = {
  queries: {
    // throwOnError: true,
    refetchOnWindowFocus: false,
    retry: false,
    staleTime: 1000 * 60,
  },
  mutations: {
    onError: (error) => {
      let message = 'Något gick fel. Försök igen senare.';

      if (!isAxiosError(error)) {
        notify.error(message);
        return;
      }

      if (error.request?.status === 400) message = 'Något gick fel. Se över dina uppgifter och försök igen!';
      if (error.request?.status === 401) message = 'Du är inte inloggad. Logga in och försök igen.';
      if (error.request?.status === 403) message = 'Du har inte behörighet att utföra denna åtgärd.';
      if (error.request?.status === 404) message = 'Resursen kunde inte hittas.';
      if (error.request?.status === 409) message = 'Resursen finns redan.';
      if (error.request?.status === 500) message = 'Något gick fel. Försök igen senare.';

      notify.error(message);
    },
    onSuccess: () => {
      notify.success('Klappat och klart!');
    },
  },
} satisfies DefaultOptions;

export const queryClient = new QueryClient({ defaultOptions: queryConfig });
